import GoogleLogo from './GoogleLogo';

interface GoogleSignInButtonProps {
  onClick: () => void;
}

export default function GoogleSignInButton({ onClick }: GoogleSignInButtonProps) {
  return (
    <button
      className="gsi-material-button"
      onClick={onClick}
      data-ph-capture-attribute="btn-google-sign-in"
    >
      <div className="gsi-material-button-state"></div>
      <div className="gsi-material-button-content-wrapper">
        <GoogleLogo />
        <span className="gsi-material-button-contents">Continue with Google</span>
        <span style={{ display: 'none' }}>Continue with Google</span>
      </div>
    </button>
  );
}
